export default {

  // Transmit to parent
  postComponentLoaded () { this.postMessageToParent('inspiComponentLoaded') },
  postProductLoaded () { this.postMessageToParent('inspiProductLoaded') },
  postError (error) { this.postMessageToParent('inspiError', { error: error }) },

  postName (name) { this.postMessageToParent('inspiName', { name: name }) },
  postPrice (price) { this.postMessageToParent('inspiPrice', { price: price }) },
  postSummary (summary) { this.postMessageToParent('inspiSummary', { summary: summary }) },
  postConfiguration (configuration) { this.postMessageToParent('inspiConfiguration', { configuration: configuration }) },
  postProject (project) { this.postMessageToParent('inspiProject', { project: project }) },

  postMessageToParent (type, data) {
    const message = { type: type }
    for (var key in data) message[key] = data[key]
    window.parent.postMessage(message, '*')
  },
}
